<span
  class="avatar"
  [attr.data-nickname]="name ? getFirstLetter() : null"
  [attr.data-format]="format"
  [ngClass]="name && 'avatar--first-letter'"
>
  <img src="assets/images/avatars/{{ id }}.svg" />
</span>
